import { useEffect, useState } from 'react';
import { Trans } from '@lingui/react/macro';
import { t } from '@lingui/core/macro';
import { createModal, LoadingIndicator, Tooltip } from '@thermon-platforms/thermon-ui-core';
import { Link } from 'react-router-dom';
import ConfigureCircuitModal from '../../circuit-view/edit-modal';
import { getDeviceUrl } from 'util/device';
import useDevicesStore from 'store/devices';
import useDeviceTypesStore from 'store/device-types';


function CircuitRow({device, parent}) {
  const [devicesStore, devicesStoreActions] = useDevicesStore();
  const [deviceTypesStore] = useDeviceTypesStore();
  const [waitingToEdit, setWaitingToEdit] = useState();
  const [registrationStatus, setRegistrationStatus] = useState();

  const updateRegistrationStatus = async () => {
    const detail = await devicesStoreActions.fetchDetail(device.id);
    setRegistrationStatus(detail?.statuses?.find(status => status.statusType == 'RegistrationStatus'));
  };

  // Check registration status on load
  useEffect(() => {
    updateRegistrationStatus();
  }, [device]);

  // When registration status changes to something other than Registered,
  // start polling for updates every minute
  useEffect(() => {
    if (!registrationStatus || registrationStatus.value == 'Registered') return;
    const interval = setInterval(() => {
      updateRegistrationStatus();
    }, 1 * 60 * 1000);
    return () => clearInterval(interval);
  }, [registrationStatus]);

  async function edit() {
    setWaitingToEdit(device.id);
    const detail = await devicesStoreActions.fetchDetail(device.id);
    const status = await devicesStoreActions.fetchStatus(device.id);

    const configureDeviceModal = createModal(
      <ConfigureCircuitModal
        device={detail}
        parent={parent}
        controller={deviceTypesStore.types.find(type => type.id == parent?.model?.deviceModel)}
        temperatureUnit={status?.temperatureUnit}
      />
    );

    setWaitingToEdit(null);

    configureDeviceModal.open()
      .then((res) => {
        // Handle update
      })
      .catch(() => {/* no-op */})
      .finally(() => {
        setWaitingToEdit(null);
      });
  }

  return (
    <tr
      className={registrationStatus && registrationStatus?.value != 'Configured' ? 'unregistered' : ''}
      key={`child-device-${device.id}`}
    >
      <td className="device-info">
        <span className={`device-icon ${device.type?.toLowerCase()}`}></span>
        <Link to={`${getDeviceUrl(devicesStore.shallowDevices.get(device.id))}`}>
          {device.name}
        </Link>
        {/* Show loading indicator while we're waiting for registration status */}
        {registrationStatus && registrationStatus?.value == 'Registered' ?
          <>&nbsp;<LoadingIndicator show={true} /></>
        : null}
        {/* Show timed out status icon if registration status is TimedOut */}
        {registrationStatus && registrationStatus?.value == 'TimedOut' ? <>
          <span
            className="status-icon timed-out"
            data-tooltip-content={t`Device registration timed out.`}
            data-tooltip-id={`timed-out-tooltip-${device.id}`}
          ><Trans>Timed Out</Trans></span>
          <Tooltip id={`timed-out-tooltip-${device.id}`} place="bottom" />
        </>: null}
      </td>
      <td>
        <button
          className={waitingToEdit == device.id ? 'settings processing' : 'settings'}
          data-tooltip-content={t`Device Settings`}
          data-tooltip-id="manage-devices-tooltip"
          disabled={waitingToEdit == device.id || !deviceTypesStore.types.length}
          onClick={() => edit()}
        >
          <Trans>Device Settings</Trans>
        </button>
      </td>
    </tr>
  );

}

export default CircuitRow;
